<div class="is-visible-content" [style.min-height]="this.minHeight + 'px'">
  <ng-content />
</div>
